import { BaseDto } from "@/shared/dtos/base-dto";

export class sensor extends BaseDto {
  public nombre!: string;
}
